import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Music2 } from "lucide-react";

export const PopularTabs = () => {
  const [songs, setSongs] = useState([]);

  useEffect(() => {
    api.get("/songs", { params: { limit: 12 } })
      .then((r) => setSongs(r.data || []))
      .catch(() => {});
  }, []);

  if (!songs.length) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 py-12" data-testid="popular-tabs-section">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-2">
        <div>
          <h2 className="font-heading text-lg md:text-lg uppercase tracking-tight text-slate-100">
            Popular drum tabs
          </h2>
          <p className="text-sm text-slate-500">Tap a song to see the groove and play it free.</p>
        </div>
        <a
          href="/api/drum-tabs"
          className="text-xs font-tab uppercase tracking-widest text-[#00f0ff] hover:text-[#33f4ff]"
          data-testid="browse-all-tabs-link"
        >
          Browse all →
        </a>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {songs.map((s) => (
          <a
            key={s.slug}
            href={`/api/drum-tab/${s.slug}`}
            className="group rounded-xl border border-white/10 bg-white/[0.02] p-4 transition-colors hover:border-[#00f0ff]/40 hover:bg-white/[0.04]"
            data-testid={`popular-tab-${s.slug}`}
          >
            <div className="flex items-center gap-2 mb-2">
              <Music2 className="w-4 h-4 text-[#00f0ff] shrink-0" />
              <span className="font-semibold text-slate-100 truncate group-hover:text-[#00f0ff]">
                {s.title}
              </span>
            </div>
            <div className="text-xs text-slate-500 truncate">{s.artist}</div>
            <div className="text-[10px] font-tab tracking-widest text-slate-600 mt-2 uppercase">
              {s.bpm ? `${s.bpm} BPM` : ""} {s.time_signature ? `· ${s.time_signature}` : ""}
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
